import { useState, useEffect } from 'react';
import { configuracionApi } from '../../services/api';
import { Configuracion, CuentaProfesional } from '../../objetos/objeto_configuracion';
import { useLoading } from '../../utils/LoadingProvider';
import { toast } from 'react-toastify';

export const useConfiguracionModel = () =>{
    const [configuracion, setconfiguracion] = useState();
    const [loadingconfiguracion, setLoading] = useState(true);
    const [errorconfiguracion, setError] = useState(null);
    const { showLoading, hideLoading, withLoading } = useLoading();

    const cargarConfiguracionDufy = async() =>{
        console.log("cargando configuracion");
        try{
            setLoading(true);
            const data = await configuracionApi.getConfiguracion();
            const configuracion_obj = Configuracion.fromJson(data);
            setconfiguracion(configuracion_obj.cuentaProfesional);
            return configuracion_obj;
        }
        catch(error){
            console.error("Error al obtener configuracion:", error);
            setError(error.message || "Error al cargar la configuracion");
            return null;
        }
        finally{
            setLoading(false);
        }
    }

    const updateConfiguracion = async(nombreEmpresa,field,valor,type = 'field',categoria = "CONFIGURACION") =>{
        return withLoading(async () =>{
            try{

                let finalUpdateData = {};
                //validar que fiel no sea nulo
                if(!field ){
                    toast.error("Este error no deberia salir");
                    return;
                }

                if(type == "field" ){
                    const datosParaValidar = { [field]: valor };
                    const solicitudTemporal = new Configuracion({});
                    solicitudTemporal.updateFromJson(datosParaValidar);
                    console.log("la sol temporarl",solicitudTemporal);
                    const valorConvertido = solicitudTemporal.getFieldValue(field);
                    console.log("el valor convertido",valorConvertido);

                    finalUpdateData = {
                        [field]: valorConvertido
                    };
                } else if(type == "array"){
                    // Log de entradas
                    console.log("--- Bloque 'array' iniciado ---");
                    console.log("Input 'field':", field);
                    // Usamos JSON.stringify para ver el objeto 'valor' completo
                    console.log("Input 'valor':", JSON.stringify(valor, null, 2));

                    const campoAnidado = field;
                    const [parteIzquierda, parteDerecha] = campoAnidado.split('.');

                    // Log del split
                    console.log("1. Resultado del split:", { parteIzquierda, parteDerecha });

                    const datosParaValidar = { [parteDerecha]: valor.value };
                    
                    // Log del objeto temporal
                    console.log("2. Objeto 'datosParaValidar' (antes de la clase):", JSON.stringify(datosParaValidar, null, 2));

                    const cuentaProfesionalTemporal = new CuentaProfesional({});
                    cuentaProfesionalTemporal.updateFromJson(datosParaValidar);
                    
                    const valorConvertido = cuentaProfesionalTemporal.getFieldValue(parteDerecha);

                    // Logs de la conversión (el paso más importante)
                    console.log("3. Valor Original (de 'valor.value'):", JSON.stringify(valor.value));
                    console.log("4. Valor Convertido (desde 'getFieldValue'):", JSON.stringify(valorConvertido));

                    finalUpdateData = {
                        "field": parteIzquierda,
                        "elementId": valor.elementId,
                        "data": {
                            [parteDerecha]: valorConvertido,
                        }
                    }

                    // Log del resultado final
                    console.log("5. 'finalUpdateData' generado:", JSON.stringify(finalUpdateData, null, 2));
                    console.log("--- Bloque 'array' finalizado ---");

                } else if(type == "array_insert"){
                    finalUpdateData = {             
                        field: field,             
                        data: valor // valor será el array completo de preguntas actualizado
                    }
                }

                console.log("a actualizar configuracion ",nombreEmpresa,finalUpdateData);
                
                const respuesta = await configuracionApi.updateConfiguracion(nombreEmpresa,finalUpdateData,type,categoria);
                
                // ✅ Verificar si fue exitoso
                if (respuesta.success) {
                    toast.success(respuesta.message || "Configuración actualizada correctamente");
                    return { success: true, data: respuesta };
                } else {
                    throw new Error(respuesta.message || "Error desconocido");
                }

            }
            catch(error){
                console.error('Error al actualizar la configuracion:', error);
                toast.error("Ocurrió un error al actualizar la configuracion");
                return { success: false, error: error };
                      
            }
        },'Actualizando configuracion');
    }

    const deleteConfiguracionCuentaProfesional = async(nombreEmpresa,cuentaProfesionalData) =>{
        return withLoading(async () =>{
            try{

                const respuesta = await configuracionApi.deleteCuentaProfesional(nombreEmpresa,cuentaProfesionalData);

                if (respuesta.success) {
                    toast.success(respuesta.message || "Cuenta profesional eliminada correctamente");
                    return { success: true, data: respuesta };
                } else {
                    throw new Error(respuesta.message || "Error desconocido");
                }

            }
            catch(error){
                toast.error("Error al eliminar la cuenta profesional");
                return { success: false, error: error };
            }
        },'Eliminado cuenta profesional')
    }

    return{
        configuracion,
        loadingconfiguracion,
        errorconfiguracion,
        cargarConfiguracionDufy,
        updateConfiguracion,
        deleteConfiguracionCuentaProfesional,
    }
}